import _ from 'lodash';
import { api } from 'shared/sdk';

export const asyncValidatePromiseWrapper = (validator, data, prevErrors) => {
  /*
    Due to the way redux forms work if the validator promise is resolved all the async errors
    are overwritten by stopSubmit.

    This causes a bug in cases where we use more then one validator (ex. for password and email)
    because when one validator is resolved it overwrites errors from the other one.

    This is why we wrap the validator promise in `asyncValidation`.
    If there are previous errors, we reject the wrapping promise even if the validator is resolved,
    this way we can throw the errors from the other validators.
  */
  const asyncValidation = (resolve, reject) => {
    validator(data)
      .then(() => {
        if (!_.isEmpty(prevErrors)) {
          reject(prevErrors);
        }
        resolve();
      })
      .catch(error => {
        reject({ ...prevErrors, ..._.get(error, 'response.data', {}) });
      });
  };

  const promise = new Promise(asyncValidation);

  return promise.catch(errors => {
    throw errors;
  });
};

export const asyncValidatePassword = values => {
  return api
    .validatePassword({
      requestBody: { password: values.password }
    })
    .catch(error => {
      throw _.get(error, 'response.data');
    });
};
